"use client";

import { useParams, useSelectedLayoutSegments } from "next/navigation";

export type SectionContext =
  | { type: "workspace" }
  | { type: "account" }
  | { type: "settings" }
  | { type: "project"; projectId: string; appId?: string };

export function useSectionContext(): SectionContext {
  const segments = useSelectedLayoutSegments();
  const params = useParams<{
    projectId?: string;
    appId?: string;
  }>();

  if (params.projectId) {
    return { type: "project", projectId: params.projectId, appId: params.appId };
  }

  const section = segments[1];
  if (section === "settings") {
    return { type: "settings" };
  }
  if (section === "account") {
    return { type: "account" };
  }

  return { type: "workspace" };
}
